import http from '@/utils/http'  //引入axios
export  const getRoute = () =>http.get('/user-center/api/menu/build')//动态获取路由
export default { 
    getRoute
}